import React from "react";
import { Link } from "react-router-dom";
import { formatCurrency, formatDate } from "../../lib/api";

export const FirmCell = ({ r }) => r.firm_id ? (
  <div>
    <div className="text-[#0A2540]">{r.firm_name || r.attorney_firm || "—"}</div>
    <div className="text-[10px] text-[#9CA3AF] font-mono">{r.firm_id}</div>
  </div>
) : (
  <div>
    <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-[#FEF3C7] text-[#92400E]" data-testid={`firm-missing-${r.loan_id}`}>firm_id missing</span>
    {r.attorney_firm && <div className="text-[10px] text-[#6B7280] mt-0.5">entered: {r.attorney_firm}</div>}
  </div>
);

export const LoanTable = ({ rows, testid, extraCol }) => (
  <div className="overflow-x-auto border border-[#E5E7EB] rounded-lg bg-white" data-testid={testid}>
    <table className="w-full text-xs">
      <thead className="bg-[#F9FAFB] text-[#6B7280] text-left">
        <tr>
          {["Loan", "Client", "Client email / phone", "Attorney", "Firm", "Status", "Funded", "Principal", "Case", "Current group"].map((h) => (
            <th key={h} className="px-3 py-2 font-medium whitespace-nowrap">{h}</th>
          ))}
          {extraCol && <th className="px-3 py-2" />}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.loan_id} className="border-t border-[#F3F4F6] align-top" data-testid={`loan-row-${r.loan_id}`}>
            <td className="px-3 py-2 font-mono whitespace-nowrap">
              <Link to={`/admin/loans/${r.loan_id}`} target="_blank" className="text-[#0066FF] hover:underline" data-testid={`loan-link-${r.loan_id}`}>{r.loan_id}</Link>
            </td>
            <td className="px-3 py-2 font-medium text-[#0A2540] whitespace-nowrap">{r.client_name || "—"}</td>
            <td className="px-3 py-2 text-[#374151]">
              <div>{r.client_email || <span className="text-[#9CA3AF]">no email</span>}</div>
              {r.client_phone && <div className="text-[#6B7280]">{r.client_phone}</div>}
            </td>
            <td className="px-3 py-2 text-[#374151]">
              <div>{r.attorney_name || "—"}</div>
              <div className="text-[#6B7280]">{r.attorney_email || "no email"}</div>
            </td>
            <td className="px-3 py-2"><FirmCell r={r} /></td>
            <td className="px-3 py-2 whitespace-nowrap">{r.current_status || "—"}</td>
            <td className="px-3 py-2 whitespace-nowrap tabular-nums">{r.funding_date ? formatDate(r.funding_date) : "—"}</td>
            <td className="px-3 py-2 whitespace-nowrap tabular-nums">{r.principal != null ? formatCurrency(r.principal) : "—"}</td>
            <td className="px-3 py-2 whitespace-nowrap">{[r.case_type, r.case_state].filter(Boolean).join(" · ") || "—"}</td>
            <td className="px-3 py-2 font-mono text-[10px] whitespace-nowrap">{r.client_group_id || <span className="text-[#9CA3AF]">none</span>}</td>
            {extraCol && <td className="px-3 py-2 whitespace-nowrap">{extraCol(r)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ChangeList = ({ changes, testid }) => (
  <div className="border border-[#E5E7EB] rounded-lg divide-y divide-[#F3F4F6] max-h-64 overflow-y-auto" data-testid={testid}>
    {changes.map((c) => (
      <div key={c.loan_id} className="px-3 py-1.5 text-xs flex items-center justify-between gap-3">
        <span><span className="font-mono">{c.loan_id}</span> <span className="text-[#6B7280]">{c.client_name}</span></span>
        <span className="font-mono text-[10px]">
          <span className="text-[#9CA3AF]">{c.from_group_id || "none"}</span> → <span className="text-[#065F46] font-semibold">{c.to_group_id || "new group"}</span>
        </span>
      </div>
    ))}
  </div>
);
